import { Checkbox, FormControlLabel } from '@mui/material';
import { CheckBoxContainer } from './shusshinkoCondition.styles';
import React, { ReactNode } from 'react';

interface CodeList {
    id: string
    value: string
}
interface InfoProps {
    infoList: CodeList[],
    searchHidden: Set<string>,
    checkCode: Set<string>,
    toggleShussinko(v: string): void,
    children?: ReactNode;
}

interface CheckBoxProps {
    checkBoxInfo: CodeList,
    checked: boolean,
    toggleShussinko(v: string): void,
}

const ShussinkoCheckBoxContainer = React.memo(ShussinkoCheckBoxComponent)
function ShussinkoCheckBoxComponent(props: InfoProps) {
    return (
        <CheckBoxContainer>
            {props.infoList.map((v) => {
                let checked = props.checkCode.has(v.id)
                return (
                    <>
                        {!props.searchHidden.has(v.id) && <><CheckBoxCompornent checkBoxInfo={v} checked={checked} toggleShussinko={props.toggleShussinko} /><br /></>}
                    </>
                )
            })}
        </CheckBoxContainer>
    )
}

const CheckBoxCompornent = React.memo((props: CheckBoxProps) => {
    return (<FormControlLabel
        sx={{ whiteSpace: "pre-wrap" }}
        label={props.checkBoxInfo.value}
        key={props.checkBoxInfo.id}
        control={<Checkbox checked={props.checked} onChange={() => props.toggleShussinko(props.checkBoxInfo.id)} />} />
    )
})

export { ShussinkoCheckBoxContainer, }
